import { Item } from '@inno-sdks/files'
import { create } from 'zustand'

type DownloadItem = {
  id: number
  label: string
  progress: number
  abortController: AbortController
  item: Item
  status: 'pending' | 'completed' | 'failed'
  onCancel: () => void
}

export type DownloaderStoreState = {
  items: Array<DownloadItem>
}

export type DownloaderStoreActions = {
  addItem(item: DownloadItem): void
  downloadProgress(id: number | string, progress: number): void
  markCompleted(id: number | string): void
  markFailed(id: number | string): void
  cancelDownload(id: number | string): void
  clearAll(): void
}

export const useDownloaderStore = create<
  DownloaderStoreState & DownloaderStoreActions
>(set => ({
  items: [],
  addItem: download => set(({ items }) => ({ items: [...items, download] })),
  downloadProgress: (id, progress) =>
    set(({ items }) => ({
      items: items.map(download =>
        download.id === id ? { ...download, progress } : download
      )
    })),
  markCompleted: id =>
    set(({ items }) => ({
      items: items.map(download =>
        download.id === id ? { ...download, status: 'completed' } : download
      )
    })),
  markFailed: id =>
    set(({ items }) => ({
      items: items.map(download =>
        download.id === id ? { ...download, status: 'failed' } : download
      )
    })),
  clearAll: () =>
    set(({ items }) => {
      items.forEach(item => {
        if (item.abortController && item.status === 'pending') {
          item.abortController.abort()
        }
      })

      return { items: [] }
    }),
  cancelDownload: id =>
    set(({ items }) => {
      const activity = items.find(item => item.id === id)

      activity?.abortController.abort()

      return {
        items: items.filter(item => item.id !== id)
      }
    })
}))
